var React = require('react');

function Copy (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M5.2002 2.5C5.2002 1.67157 5.87177 1 6.7002 1H13.0002C13.8286 1 14.5002 1.67157 14.5002 2.5V10.8C14.5002 11.6284 13.8286 12.3 13.0002 12.3H6.7002C5.87177 12.3 5.2002 11.6284 5.2002 10.8V2.5ZM6.7002 2.3H13.0002C13.1107 2.3 13.2002 2.38954 13.2002 2.5V10.8C13.2002 10.9105 13.1107 11 13.0002 11H6.7002C6.58974 11 6.5002 10.9105 6.5002 10.8V2.5C6.5002 2.38954 6.58974 2.3 6.7002 2.3Z","fill":"currentColor","key":0}),React.createElement("path",{"d":"M3.8 4.65C3.8 4.29101 3.50899 4 3.15 4C2.79101 4 2.5 4.29101 2.5 4.65V13.35C2.5 14.2613 3.23873 15 4.15 15H10.85C11.209 15 11.5 14.709 11.5 14.35C11.5 13.991 11.209 13.7 10.85 13.7H4.15C3.9567 13.7 3.8 13.5433 3.8 13.35V4.65Z","fill":"currentColor","key":1})]);
}

Copy.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none"};

module.exports = Copy;

Copy.default = Copy;
